import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { EmailService } from '../services/email.service';

@Component({
  selector: 'mm-part7',
  templateUrl: './part7.component.html',
  styleUrls: ['./part7.component.scss']
})
export class Part7Component implements OnInit {

  detailsForm: FormGroup;

  constructor(private emailService: EmailService, private fb: FormBuilder) {
    this.detailsForm = this.fb.group({
      nvName: new FormControl(null, Validators.required),
      nvPhone: new FormControl(null, [Validators.pattern('^[0-9]*$'), Validators.minLength(9), Validators.maxLength(11), Validators.required]),
      nvEmail: new FormControl(null, [Validators.email, Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  submitForm(formDirective: FormGroupDirective) {
    if (this.detailsForm.valid) {
      this.emailService.sendEmail(
        this.detailsForm.get('nvEmail').value,
        this.detailsForm.get('nvName').value,
        'הזמנת אירוע משותף',
        `
        <strong>${this.detailsForm.get('nvName').value}</strong> מעוניין להזמין אירוע<br>
       ליצירת קשר:<br>
        מייל - ${this.detailsForm.get('nvEmail').value}<br>
        טלפון - ${this.detailsForm.get('nvPhone').value}<br>
        <br>
        `)
        .then(res => {
          if (res) {
            console.log(res);
            const msg = `\n
            המייל נשלח בהצלחה!\n
            בקרוב יצרו איתך קשר מהמערכת להמשך ההזמנה`;
            alert(msg);
          } else {
            throw new Error('server error');
          }
        })
        .catch(err => {
          console.error(err);
          const msg = `\n
          אופס :( \n
          נראה שאירעה שגיאה במהלך שליחת המייל \n
          אנא נסה שוב מאוחר יותר`;
          alert(msg);
        })
        .finally(() => {
          formDirective.resetForm();
          this.detailsForm.reset();
          // stop waiting
        });
    }
  }

}
